import { render, staticRenderFns } from "./TagCloseIcon.vue?vue&type=template&id=7f20d7ab"
import script from "./TagCloseIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./TagCloseIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports